export const NOTIFICATION_CENTER_PAGE_SIZE = 20;
export const NOTIFICATION_CENTER_DEADLINES_TAB_ID = "deadlines";
export const NOTIFICATION_CENTER_SETTINGS_TAB_ID = "settings";

/** Tables loaded via generic fetchNotificationCenterTable (offset/limit). Deadlines use a dedicated thunk with deadline_filter. */
export function isNotificationCenterPaginatedTable(tableId) {
  return Boolean(tableId) && tableId !== NOTIFICATION_CENTER_DEADLINES_TAB_ID;
}

export const NOTIFICATION_CENTER_TAB_KEYS = [
  "reporting",
  "messages",
  "cases",
  "charge_invoices",
  "product",
  "settings",
  "registrations",
  "deadlines",
];
